import { makeStyles } from '@mui/styles'

export default makeStyles({
  logo: {
    '&&': {
      height: 'initial',
      marginRight: '0',
      width: 'initial',
    },
  },
})
